import { render } from "./HomeContact.vue?vue&type=template&id=56c4ebd8"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__